import { render, staticRenderFns } from "./goodsUpdate.vue?vue&type=template&id=6b9eb59e&"
import script from "./goodsUpdate.vue?vue&type=script&lang=js&"
export * from "./goodsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./goodsUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports